import * as stylex from '@stylexjs/stylex'

export const mobileStyles = stylex.create({
    page: {
        display: 'flex',
        minWidth: 0,
        flexDirection: 'column',
        rowGap: '18px',
        paddingBottom: '4px',
    },
    header: {
        display: 'flex',
        minWidth: 0,
        alignItems: 'start',
        justifyContent: 'space-between',
        gap: '12px',
    },
    eyebrow: {
        color: '#5e8e68',
        fontSize: '11px',
        fontWeight: 600,
        textTransform: 'uppercase',
        letterSpacing: '.08em',
    },
    title: {
        marginTop: '4px',
        fontSize: '27px',
        fontWeight: 650,
        letterSpacing: '-.04em',
        lineHeight: '1.08',
    },
    subtitle: {
        marginTop: '5px',
        color: '#748077',
        fontSize: '13px',
        lineHeight: '1.25rem',
    },
    fields: {
        display: 'grid',
        gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
        gap: '10px',
        '@media (max-width: 380px)': {
            gridTemplateColumns: '1fr',
        },
    },
    card: {
        minWidth: 0,
        borderWidth: 1,
        borderColor: '#e1e8df',
        borderRadius: '1.125rem',
        backgroundColor: '#fff',
        padding: '16px',
        boxShadow: '0 2px 8px rgb(38 59 42 / 4%)',
    },
    greenCard: {
        borderColor: '#72a77d',
        backgroundColor: '#4c9560',
        color: '#fff',
        boxShadow: '0 8px 22px rgb(56 119 73 / 16%)',
    },
    greenCardLabel: { color: 'rgb(255 255 255 / 78%)' },
    greenCardSubtitle: { color: 'rgb(255 255 255 / 82%)' },
    cardTitle: {
        fontSize: '16px',
        fontWeight: 650,
        lineHeight: '1.2rem',
    },
    cardLabel: {
        color: '#748077',
        fontSize: '11px',
        fontWeight: 600,
        textTransform: 'uppercase',
        letterSpacing: '.06em',
    },
    cardValue: {
        marginTop: '6px',
        fontSize: '22px',
        fontWeight: 650,
        letterSpacing: '-.025em',
    },
    muted: {
        color: '#748077',
        fontSize: '12px',
        lineHeight: '1.1rem',
    },
    button: {
        display: 'inline-flex',
        minHeight: '44px',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '7px',
        borderRadius: '0.75rem',
        backgroundColor: '#408b56',
        paddingInline: '14px',
        fontSize: '13px',
        fontWeight: 600,
        color: '#fff',
        ':hover': { backgroundColor: '#347c48' },
    },
    secondaryButton: {
        display: 'inline-flex',
        minHeight: '44px',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '7px',
        borderWidth: 1,
        borderColor: '#dbe5d9',
        borderRadius: '0.75rem',
        backgroundColor: '#fff',
        paddingInline: '13px',
        fontSize: '13px',
        fontWeight: 600,
        color: '#4e7057',
        ':hover': { backgroundColor: '#f2f8f1' },
    },
    list: {
        display: 'flex',
        minWidth: 0,
        flexDirection: 'column',
    },
    listItem: {
        display: 'flex',
        width: '100%',
        minWidth: 0,
        minHeight: '68px',
        alignItems: 'center',
        gap: '11px',
        borderBottomWidth: 1,
        borderColor: '#edf0eb',
        paddingBlock: '12px',
        textAlign: 'left',
        WebkitTapHighlightColor: 'transparent',
        ':last-child': { borderBottomWidth: 0 },
        ':active': { opacity: 0.72 },
    },
    listMain: {
        minWidth: 0,
        flex: '1 1 0%',
    },
    listTitle: {
        display: 'block',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        color: '#303b33',
        fontSize: '13px',
        fontWeight: 650,
    },
    listMeta: {
        display: 'block',
        overflow: 'hidden',
        marginTop: '3px',
        color: '#7b857d',
        fontSize: '11px',
        lineHeight: '1rem',
        textOverflow: 'ellipsis',
    },
    listAmount: {
        flexShrink: 0,
        whiteSpace: 'nowrap',
        textAlign: 'right',
        fontSize: '13px',
        fontWeight: 700,
        letterSpacing: '-.01em',
    },
    positive: { color: '#397a4b' },
    negative: { color: '#a5501d' },
    empty: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '8px',
        paddingBlock: '28px',
        textAlign: 'center',
    },
    emptyIcon: {
        display: 'flex',
        height: '44px',
        width: '44px',
        flexShrink: 0,
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '9999px',
        backgroundColor: '#edf6eb',
        color: '#468554',
    },
    tabs: {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
        gap: '4px',
        borderRadius: '0.75rem',
        backgroundColor: '#edf3eb',
        padding: '4px',
    },
    tab: {
        minHeight: '38px',
        borderRadius: '0.5rem',
        color: '#68756c',
        fontSize: '11px',
        fontWeight: 600,
        textTransform: 'capitalize',
    },
    tabActive: {
        backgroundColor: '#fff',
        color: '#397a4b',
        boxShadow: '0 1px 2px rgb(38 59 42 / 8%)',
    },
    avatarRow: {
        display: 'flex',
        minWidth: 0,
        alignItems: 'center',
        gap: '10px',
    },
    rowActions: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: '8px',
        marginTop: '14px',
    },
})
